// Generated by purs version 0.15.0
import * as Data_Array from "../Data.Array/index.js";
import * as Data_Eq from "../Data.Eq/index.js";
import * as Data_Eq_Generic from "../Data.Eq.Generic/index.js";
import * as Data_Foldable from "../Data.Foldable/index.js";
import * as Data_Functor from "../Data.Functor/index.js";
import * as Data_Map_Internal from "../Data.Map.Internal/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Money_Rounded from "../Data.Money.Rounded/index.js";
import * as Data_Monoid from "../Data.Monoid/index.js";
import * as Data_Newtype from "../Data.Newtype/index.js";
import * as Data_Ord from "../Data.Ord/index.js";
import * as Data_Ord_Generic from "../Data.Ord.Generic/index.js";
import * as Data_Ordering from "../Data.Ordering/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Data_Show_Generic from "../Data.Show.Generic/index.js";
import * as Foreign_Encoding from "../Foreign.Encoding/index.js";
import * as Foreign_Generic_Class from "../Foreign.Generic.Class/index.js";
import * as Restaumatic_Menu_V2_Types_Ids_EntityId from "../Restaumatic.Menu.V2.Types.Ids.EntityId/index.js";
import * as Restaumatic_Menu_V2_Types_ItemId from "../Restaumatic.Menu.V2.Types.ItemId/index.js";
import * as Unscramble from "../Unscramble/index.js";
var ProductItemKey = function (x) {
    return x;
};
var ProductId = function (x) {
    return x;
};
var ProductItem = function (x) {
    return x;
};
var udecodeProductId = /* #__PURE__ */ Unscramble.decodeRecord1()(/* #__PURE__ */ Unscramble.decodeRecordCons({
    reflectSymbol: function () {
        return "productId";
    }
})(/* #__PURE__ */ Unscramble.decodeMaybe(Unscramble.decodeInt1))(Unscramble.decodeRecordNil));
var productId = function (v) {
    return v.productId;
};
var productCategoryId = function (v) {
    return v.productCategoryId;
};
var newtypeProductItemKey = {
    Coercible0: function () {
        return undefined;
    }
};
var newtypeProductItem = {
    Coercible0: function () {
        return undefined;
    }
};
var product = /* #__PURE__ */ (function () {
    var $59 = Data_Newtype.unwrap();
    var $60 = Data_Newtype.unwrap();
    return function ($61) {
        return (function (v) {
            return v.product;
        })($59((function (v) {
            return v.productItemKey;
        })($60($61))));
    };
})();
var productItemKey = /* #__PURE__ */ (function () {
    var $62 = Data_Newtype.unwrap();
    return function ($63) {
        return (function (v) {
            return v.productItemKey;
        })($62($63));
    };
})();
var productName = /* #__PURE__ */ (function () {
    var $64 = Data_Newtype.unwrap();
    return function ($65) {
        return (function (v) {
            return v.productName;
        })($64($65));
    };
})();
var productPrice = /* #__PURE__ */ (function () {
    var $66 = Data_Newtype.unwrap();
    return function ($67) {
        return (function (v) {
            return v.productPrice;
        })($66($67));
    };
})();
var productSeq = /* #__PURE__ */ (function () {
    var $68 = Data_Newtype.unwrap();
    var $69 = Data_Newtype.unwrap();
    return function ($70) {
        return (function (v) {
            return v.productSeq;
        })($68((function (v) {
            return v.productItemKey;
        })($69($70))));
    };
})();
var newtypeProductId = {
    Coercible0: function () {
        return undefined;
    }
};
var mkProductItemKey = function (prod) {
    return function (prodSeq) {
        return {
            product: prod,
            productSeq: prodSeq
        };
    };
};
var mkProductItem = function (template) {
    return function (prod) {
        return function (prodSeq) {
            return {
                productItemKey: mkProductItemKey(prod)(prodSeq),
                productName: template.productName,
                productPrice: template.productPrice,
                productId: template.productId,
                productCategoryId: template.productCategoryId,
                itemId: template.itemId,
                customParameters: template.customParameters,
                isCombo: template.isCombo
            };
        };
    };
};
var mkProductItems = function (template) {
    return function (prod) {
        return function (count) {
            return Data_Functor.mapFlipped(Data_Functor.functorArray)(Data_Array.range(1)(count))(mkProductItem(template)(prod));
        };
    };
};
var mkProductId = function (id) {
    return {
        productId: new Data_Maybe.Just(id)
    };
};
var mkGenericProductId = /* #__PURE__ */ (function () {
    return {
        productId: Data_Maybe.Nothing.value
    };
})();
var itemId = function (v) {
    return v.itemId;
};
var isCombo = function (v) {
    return v.isCombo;
};
var genericProductItemKey = {
    to: function (x) {
        return x;
    },
    from: function (x) {
        return x;
    }
};
var showProductItemKey = function (dictShow) {
    return {
        show: Data_Show_Generic.genericShow(genericProductItemKey)(Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsArgument(Data_Show.showRecord()()(Data_Show.showRecordFieldsCons({
            reflectSymbol: function () {
                return "product";
            }
        })(Data_Show.showRecordFieldsCons({
            reflectSymbol: function () {
                return "productSeq";
            }
        })(Data_Show.showRecordFieldsNil)(Data_Show.showInt))(dictShow))))({
            reflectSymbol: function () {
                return "ProductItemKey";
            }
        }))
    };
};
var genericProductItem = {
    to: function (x) {
        return x;
    },
    from: function (x) {
        return x;
    }
};
var genericProductId = {
    to: function (x) {
        return x;
    },
    from: function (x) {
        return x;
    }
};
var showProductId = {
    show: /* #__PURE__ */ Data_Show_Generic.genericShow(genericProductId)(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(/* #__PURE__ */ Data_Show.showRecord()()(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "productId";
        }
    })(Data_Show.showRecordFieldsNil)(/* #__PURE__ */ Data_Maybe.showMaybe(Data_Show.showInt)))))({
        reflectSymbol: function () {
            return "ProductId";
        }
    }))
};
var showProductItem = function (dictShow) {
    return {
        show: Data_Show_Generic.genericShow(genericProductItem)(Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsArgument(Data_Show.showRecord()()(Data_Show.showRecordFieldsCons({
            reflectSymbol: function () {
                return "customParameters";
            }
        })(Data_Show.showRecordFieldsCons({
            reflectSymbol: function () {
                return "isCombo";
            }
        })(Data_Show.showRecordFieldsCons({
            reflectSymbol: function () {
                return "itemId";
            }
        })(Data_Show.showRecordFieldsCons({
            reflectSymbol: function () {
                return "productCategoryId";
            }
        })(Data_Show.showRecordFieldsCons({
            reflectSymbol: function () {
                return "productId";
            }
        })(Data_Show.showRecordFieldsCons({
            reflectSymbol: function () {
                return "productItemKey";
            }
        })(Data_Show.showRecordFieldsCons({
            reflectSymbol: function () {
                return "productName";
            }
        })(Data_Show.showRecordFieldsCons({
            reflectSymbol: function () {
                return "productPrice";
            }
        })(Data_Show.showRecordFieldsNil)(Data_Money_Rounded.showMoney))(Data_Show.showString))(showProductItemKey(dictShow)))(showProductId))(Data_Maybe.showMaybe(Restaumatic_Menu_V2_Types_Ids_EntityId.showEntityId)))(Data_Maybe.showMaybe(Restaumatic_Menu_V2_Types_ItemId.showItemId)))(Data_Show.showBoolean))(Data_Map_Internal.showMap(Restaumatic_Menu_V2_Types_Ids_EntityId.showEntityId)(Restaumatic_Menu_V2_Types_Ids_EntityId.showEntityId)))))({
            reflectSymbol: function () {
                return "ProductItem";
            }
        }))
    };
};
var functorProductItemKey = {
    map: function (f) {
        return function (m) {
            return {
                product: f(m.product),
                productSeq: m.productSeq
            };
        };
    }
};
var eqProductItemKey = function (dictEq) {
    return {
        eq: Data_Eq_Generic.genericEq(genericProductItemKey)(Data_Eq_Generic.genericEqConstructor(Data_Eq_Generic.genericEqArgument(Data_Eq.eqRec()(Data_Eq.eqRowCons(Data_Eq.eqRowCons(Data_Eq.eqRowNil)()({
            reflectSymbol: function () {
                return "productSeq";
            }
        })(Data_Eq.eqInt))()({
            reflectSymbol: function () {
                return "product";
            }
        })(dictEq)))))
    };
};
var ordProductItemKey = function (dictOrd) {
    return {
        compare: Data_Ord_Generic.genericCompare(genericProductItemKey)(Data_Ord_Generic.genericOrdConstructor(Data_Ord_Generic.genericOrdArgument(Data_Ord.ordRecord()(Data_Ord.ordRecordCons(Data_Ord.ordRecordCons(Data_Ord.ordRecordNil)()({
            reflectSymbol: function () {
                return "productSeq";
            }
        })(Data_Ord.ordInt))()({
            reflectSymbol: function () {
                return "product";
            }
        })(dictOrd))))),
        Eq0: function () {
            return eqProductItemKey(dictOrd.Eq0());
        }
    };
};
var eqProductId = {
    eq: function (x) {
        return function (y) {
            return Data_Eq.eq(Data_Maybe.eqMaybe(Data_Eq.eqInt))(x.productId)(y.productId);
        };
    }
};
var eqProductItem = function (dictEq) {
    return {
        eq: Data_Eq_Generic.genericEq(genericProductItem)(Data_Eq_Generic.genericEqConstructor(Data_Eq_Generic.genericEqArgument(Data_Eq.eqRec()(Data_Eq.eqRowCons(Data_Eq.eqRowCons(Data_Eq.eqRowCons(Data_Eq.eqRowCons(Data_Eq.eqRowCons(Data_Eq.eqRowCons(Data_Eq.eqRowCons(Data_Eq.eqRowCons(Data_Eq.eqRowNil)()({
            reflectSymbol: function () {
                return "productPrice";
            }
        })(Data_Money_Rounded.eqMoney))()({
            reflectSymbol: function () {
                return "productName";
            }
        })(Data_Eq.eqString))()({
            reflectSymbol: function () {
                return "productItemKey";
            }
        })(eqProductItemKey(dictEq)))()({
            reflectSymbol: function () {
                return "productId";
            }
        })(eqProductId))()({
            reflectSymbol: function () {
                return "productCategoryId";
            }
        })(Data_Maybe.eqMaybe(Restaumatic_Menu_V2_Types_Ids_EntityId.eqEntityId)))()({
            reflectSymbol: function () {
                return "itemId";
            }
        })(Data_Maybe.eqMaybe(Restaumatic_Menu_V2_Types_ItemId.eqItemId)))()({
            reflectSymbol: function () {
                return "isCombo";
            }
        })(Data_Eq.eqBoolean))()({
            reflectSymbol: function () {
                return "customParameters";
            }
        })(Data_Map_Internal.eqMap(Restaumatic_Menu_V2_Types_Ids_EntityId.eqEntityId)(Restaumatic_Menu_V2_Types_Ids_EntityId.eqEntityId))))))
    };
};
var ordProductId = {
    compare: function (x) {
        return function (y) {
            return Data_Ord.compare(Data_Maybe.ordMaybe(Data_Ord.ordInt))(x.productId)(y.productId);
        };
    },
    Eq0: function () {
        return eqProductId;
    }
};
var encodeProductItemKey = function (dictEncode) {
    return function (dictEncodeWithOptions) {
        return {
            encode: Foreign_Encoding.defaultEncode(genericProductItemKey)(Foreign_Generic_Class.genericEncodeConstructor({
                reflectSymbol: function () {
                    return "ProductItemKey";
                }
            })(Foreign_Generic_Class.genericEncodeArgsRecord(Foreign_Generic_Class.encodeWithOptionsRecord()(Foreign_Generic_Class.encodeRecordCons()(Foreign_Generic_Class.encodeRecordCons()(Foreign_Generic_Class.encodeRecordNil)({
                reflectSymbol: function () {
                    return "productSeq";
                }
            })(Foreign_Generic_Class.encodeWithOptionsOther(Foreign_Generic_Class.intEncode)))({
                reflectSymbol: function () {
                    return "product";
                }
            })(dictEncodeWithOptions)))))
        };
    };
};
var encodeProductId = {
    encode: /* #__PURE__ */ Foreign_Encoding.defaultEncode(genericProductId)(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeConstructor({
        reflectSymbol: function () {
            return "ProductId";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeArgsRecord(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsRecord()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(Foreign_Generic_Class.encodeRecordNil)({
        reflectSymbol: function () {
            return "productId";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(/* #__PURE__ */ Foreign_Generic_Class.maybeEncode(Foreign_Generic_Class.intEncode)))))))
};
var decodeProductItemKey = function (dictDecode) {
    return function (dictDecodeWithOptions) {
        return {
            decode: Foreign_Encoding.defaultDecode(genericProductItemKey)(Foreign_Generic_Class.genericDecodeConstructor({
                reflectSymbol: function () {
                    return "ProductItemKey";
                }
            })(Foreign_Generic_Class.genericDecodeArgsRecord(Foreign_Generic_Class.decodeWithOptionsRecord()(Foreign_Generic_Class.decodeRecordCons()(Foreign_Generic_Class.decodeRecordCons()(Foreign_Generic_Class.decodeRecordNil)({
                reflectSymbol: function () {
                    return "productSeq";
                }
            })(Foreign_Generic_Class.decodeWithOptionsOther(Foreign_Generic_Class.intDecode))())({
                reflectSymbol: function () {
                    return "product";
                }
            })(dictDecodeWithOptions)())))(Foreign_Generic_Class.genericCountArgsArgument))
        };
    };
};
var decodeProductId = {
    decode: /* #__PURE__ */ Foreign_Encoding.defaultDecode(genericProductId)(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeConstructor({
        reflectSymbol: function () {
            return "ProductId";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeArgsRecord(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsRecord()(/* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons()(Foreign_Generic_Class.decodeRecordNil)({
        reflectSymbol: function () {
            return "productId";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(/* #__PURE__ */ Foreign_Generic_Class.maybeDecode(Foreign_Generic_Class.intDecode)))())))(Foreign_Generic_Class.genericCountArgsArgument))
};
var customParameters = function (v) {
    return v.customParameters;
};
var ordProductItem = function (dictOrd) {
    return {
        compare: function (a) {
            return function (b) {
                return Data_Foldable.fold(Data_Foldable.foldableArray)(Data_Monoid.monoidOrdering)([ Data_Ordering.invert(Data_Ord.compare(Data_Money_Rounded.ordMoney)(productPrice(a))(productPrice(b))), Data_Ord.compare(Data_Ord.ordString)(productName(a))(productName(b)), Data_Ord.compare(Data_Maybe.ordMaybe(Restaumatic_Menu_V2_Types_Ids_EntityId.ordEntityId))(productCategoryId(a))(productCategoryId(b)), Data_Ord.compare(Data_Maybe.ordMaybe(Restaumatic_Menu_V2_Types_ItemId.ordItemId))(itemId(a))(itemId(b)), Data_Ord.compare(Data_Map_Internal.ordMap(Restaumatic_Menu_V2_Types_Ids_EntityId.ordEntityId)(Restaumatic_Menu_V2_Types_Ids_EntityId.ordEntityId))(customParameters(a))(customParameters(b)), Data_Ord.compare(Data_Ord.ordBoolean)(isCombo(a))(isCombo(b)), Data_Ord.compare(ordProductItemKey(dictOrd))(productItemKey(a))(productItemKey(b)) ]);
            };
        },
        Eq0: function () {
            return eqProductItem(dictOrd.Eq0());
        }
    };
};
var customParameterValues = function (v) {
    return function (customParameterId) {
        return Data_Map_Internal.lookup(Restaumatic_Menu_V2_Types_Ids_EntityId.ordEntityId)(customParameterId)(v.customParameters);
    };
};
export {
    ProductItem,
    ProductItemKey,
    ProductId,
    mkProductId,
    mkGenericProductId,
    mkProductItemKey,
    mkProductItem,
    mkProductItems,
    productItemKey,
    product,
    productSeq,
    productPrice,
    productName,
    productId,
    productCategoryId,
    itemId,
    isCombo,
    customParameters,
    customParameterValues,
    newtypeProductItem,
    genericProductItem,
    showProductItem,
    eqProductItem,
    ordProductItem,
    functorProductItemKey,
    newtypeProductItemKey,
    genericProductItemKey,
    encodeProductItemKey,
    decodeProductItemKey,
    showProductItemKey,
    eqProductItemKey,
    ordProductItemKey,
    newtypeProductId,
    genericProductId,
    eqProductId,
    ordProductId,
    showProductId,
    encodeProductId,
    decodeProductId,
    udecodeProductId
};
//# sourceMappingURL=index.js.map
